import { cn } from "@/lib/utils";
import type { PropsWithChildren } from "react";

export function LineLabel({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) {
  return (
    <div className={cn("relative", className)}>
      <div className="absolute inset-0 flex items-center">
        <span className="w-full border-t" />
      </div>
      <div className="relative flex justify-center text-xs uppercase">
        {children}
      </div>
    </div>
  );
}

LineLabel.displayName = "LineLabel";
